module.exports = __webpack_public_path__ + "img/anteraja.ccb6c9fd.png";